const InvalidBox = ({ msg }) => {
  return <p className={`notify notify-danger`}>{msg}</p>;
};

export default InvalidBox;
